import React from 'react';
import { connect } from 'dva';
import ABSPanel from '../../../../../components/ABSPanel';
import ABSNewsPanel from '../../../../../components/ABSNewsPanel';
import ABSNoContent from '../../../../../components/ABSNoContent';
import ABSInfiniteScroll from '../../../../../components/ABSInfiniteScroll';

export interface IHotNewsProps {
  homePageHotNews?: any;
  dispatch?: any;
  HotNewsHasMore?: boolean;
  getScrollParent?: any;
}
 
export interface IHotNewsState {

}
 
class HotNews extends React.Component<IHotNewsProps, IHotNewsState> {
  pageIndex;
  scrollDom;
  componentDidMount() {
    this.props.dispatch({
      type: 'home/getHomePageHotNews',
      payload: {
        page_index: 1,
        page_size: 30
      }
    }).then((res) => {
      if (res) {
        this.pageIndex = 1;
      }
    });
  }

  hotNewsList = () => {
    const { homePageHotNews } = this.props;
    const hotNewList = homePageHotNews.items;

    if (!hotNewList || hotNewList.length === 0) {
      return <ABSNoContent />;
    } else {
      return hotNewList.map((newsList, index) => {
        return (
          <ABSNewsPanel
            key={index}
            children={newsList.title}
            bottomText={`来源 ：${newsList.source} | ${newsList.publish_date}`}
            id={newsList.id}
            news_type_id={newsList.news_type_id}
            url={newsList.source_url}
            isHideHot={index > 4}
          />
        );

      });
    }
  }

  onLoadMore = () => {
    const { homePageHotNews, dispatch } = this.props;
    const hotNewList = homePageHotNews.items;

    if (!hotNewList || hotNewList.length <= 0) {
      return;
    }

    dispatch({
      type: 'home/getHomePageHotNews',
      payload: {
        page_index: homePageHotNews.current_page + 1
      }
    }).then((res) => {
      if (res) {
        this.pageIndex = homePageHotNews.current_page;
        return;
      }
    });
    return ;
  }
  
  render() { 
    const { getScrollParent, HotNewsHasMore } = this.props; // getScrollParent,
    return ( 
      <ABSPanel 
        title="热门资讯" 
        removePadding={true} 
        className="abs-home-hot-news" 
        isClearBackground={true}
      >
        <ABSInfiniteScroll
          onLoadMore={this.onLoadMore}
          hasMore={HotNewsHasMore}
          getScrollParent={getScrollParent}
        >
          {this.hotNewsList()}
        </ABSInfiniteScroll>
      </ABSPanel>
     );
  }
}

function mapStateToProps({ home, global, loading }: any) {
  const { homePageHotNews, HotNewsHasMore } = home;
  return { homePageHotNews, HotNewsHasMore };
}

export default connect(mapStateToProps)(HotNews);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/middle/HotNews.tsx